/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStore, reconcile } from "solid-js/store";

import {
  postGetFreeUserPromoItemList,
  postGetUserPromoItemList,
  useUserPromoItem,
} from "@/api/clientApi/activity";
import { useDialog } from "@/components/Dialogs/useDialog.ts";
import { APP_ID } from "@/constants/constants";
import { useGame } from "@/hooks/game/useGame";
import { useRouter } from "@/hooks/useRouter";
import {
  getGameimgurlByGameId,
  getImgUrlPro,
  getImgurl,
} from "@/lib/resFolder";
import { getUserInfo, userStore } from "@/stores/userStore";
import { PropEnum } from "@/types/compontent/base/baseEnum";
import { UserPromoItem } from "@/types/swagger/promoItem";

export interface PropsStoreList extends UserPromoItem {
  url: string;
  button?: string;
  button_type?: number; //1:正常按钮 2:半透明按钮
  clock: boolean; //锁定
  cfg_data: any;
  freeSingleId?: string; // 免费游戏道具单个游戏id
}
// 原始数据
const initialPropsStore: PropsStore = {
  list: [],
  inuse: [],
  unuse: [],
  propsTypes: [PropEnum.deposit, PropEnum.vipAdd, PropEnum.freeBet],
  loading: true,
};
// store
export const [propsStore, setPropsStore] = createStore<PropsStore>(
  JSON.parse(JSON.stringify(initialPropsStore)),
);

interface PropsStore {
  list: PropsStoreList[]; //列表数据
  propsTypes: number[]; //道具类型
  inuse: PropsStoreList[]; //使用中的道具
  unuse: PropsStoreList[]; //未使用过的道具
  loading: boolean; //加载中
}
export function useProps() {
  const { operateDialog } = useDialog();
  const { toDeposit } = useRouter();
  const { enterGame } = useGame();

  // 使用道具
  const usePropsItem = async (itemId: string) => {
    const params = {
      item_id: itemId,
      app_id: APP_ID,
      user_id: userStore.userInfo?.uid ?? 0,
    };
    await useUserPromoItem(params)?.then((res) => {
      console.log(res);
    });
  };
  //跳转club事件
  const handleVipClub = (push: (path: string) => void) => {
    operateDialog("PropsList");
    operateDialog("VipExperience");
    push("vip");
  };
  //   道具使用事件
  const handlePropsButton = (
    item: PropsStoreList,
    push: (path: string) => void,
  ) => {
    switch (item.promo_type) {
      case PropEnum.deposit:
        toDeposit({
          dialogCallback: () => {},
          itemId: item.item_id,
        });
        break;
      case PropEnum.vipAdd:
        usePropsItem(item.item_id).then(() => {
          getUserInfo().then(() => {
            usePropsInit().getUserPromoItemList();
            const exp = (
              (item.cfg_data?.VipPointAddCfg?.vip_point ?? 0) / 100
            ).toFixed(2);
            operateDialog("VipExperience", true, {
              vipExp: exp,
            });
          });
        });
        break;
      case PropEnum.freeBet:
        if (item.used_status && item.bind_game_id) {
          // 使用过直接进入游戏
          operateDialog("PropsList");
          enterGame(item.bind_game_id, item?.item_id);
        } else {
          // 单个游戏
          if (item.freeSingleId) {
            operateDialog("PropsList");
            enterGame(Number(item.freeSingleId), item?.item_id);
          } else {
            operateDialog("FreeGame", true, {
              list: JSON.parse(item.cfg_data?.config)?.items ?? [],
              itemId: item?.item_id,
            });
          }
        }
        break;
      case PropEnum.casualGame:
        operateDialog("PropsList");
        push("casual-games");
        break;
      default:
        break;
    }
  };
  // 初始化
  const initPropsStore = () => {
    // setPropsStore(reconcile(initialPropsStore));
    return usePropsInit().getUserPromoItemList();
  };

  // 清除倒计时结束的道具
  const clearDownTimeProps = (itemId: string) => {
    const list = propsStore?.list?.filter((item) => item.item_id != itemId);
    setPropsStore("list", reconcile(list));
  };
  return {
    initPropsStore,
    handlePropsButton,
    usePropsItem,
    handleVipClub,
    clearDownTimeProps,
  };
}

export function usePropsInit() {
  //获取道具列表
  const getUserPromoItemList = async () => {
    const params = {
      limit: 10000,
      page: 1,
      used_status: -1,
    };
    setPropsStore("loading", true);
    const [userList, freeList] = await Promise.all([
      postGetUserPromoItemList(params),
      postGetFreeUserPromoItemList(params),
    ]);
    setPropsStore("loading", false);
    const newFreeList =
      freeList?.list?.filter((item) => item.used_status == 2) ?? [];
    const list = [...(userList?.list || []), ...newFreeList];
    if (list.length) {
      setPropsStore(
        "list",
        reconcile(filterListData(list as PropsStoreList[])),
      );
    } else {
      setPropsStore("list", reconcile([]));
    }

    const inuse = [] as any[];
    const unuse = [] as any[];
    userList?.list?.forEach((item) => {
      if (item.promo_type != PropEnum.freeBet) {
        // 6 免费游戏道具用另一个接口数据统计
        if (item.used_status == 1) {
          inuse.push(item);
        } else if (item.used_status == 0) {
          unuse.push(item);
        }
      }
    });
    freeList?.list?.forEach((item) => {
      if (item.used_status == 2) {
        // 2 使用中 次接口只返回 0和 2
        inuse.push(item);
      } else {
        unuse.push(item);
      }
    });
    setPropsStore(
      "inuse",
      reconcile(filterListData(inuse as PropsStoreList[])),
    );
    setPropsStore(
      "unuse",
      reconcile(filterListData(unuse as PropsStoreList[])),
    );
  };
  // 配置映射表
  const promoTypeConfigMap: Record<number, Partial<PropsStoreList>> = {
    [PropEnum.deposit]: {
      url: getImgUrlPro("img1.png", "props"),
      button: "item.deposit",
      button_type: 1,
      clock: false,
    },
    [PropEnum.vipAdd]: {
      url: getImgurl("img5.png", "bonusCenter/props"),
      button: "item.use",
      button_type: 1,
      clock: false,
    },
    [PropEnum.freeBet]: {
      url: getImgurl("img6.png", "bonusCenter/props"),
      button: "item.spin_now",
      button_type: 1,
      clock: false,
    },
  };
  // 安全 JSON 解析
  function safeParseJSON<T = unknown>(data: unknown, fallback: T = {} as T): T {
    if (typeof data === "object" && data !== null) return data as T;
    if (typeof data !== "string") return fallback;
    try {
      return JSON.parse(data) as T;
    } catch {
      return fallback;
    }
  }
  // 道具列表数据
  const filterListData = (arr: PropsStoreList[]) => {
    const list: PropsStoreList[] = arr
      ?.filter((item) => propsStore?.propsTypes?.includes(item.promo_type))
      .map((item) => {
        let config: Partial<PropsStoreList> = {};
        let freeSingleId = "";
        if (item.promo_type == PropEnum.freeBet) {
          const freeBetConfig = JSON.parse(item.cfg_data) || {};
          const freeBetItems = JSON.parse(freeBetConfig.config)?.items || [];
          if (freeBetItems?.length == 1) {
            // 处理免费投注单个游戏情况
            freeSingleId = freeBetItems[0]?.game_id || "";
            config = {
              ...promoTypeConfigMap[item.promo_type],
              url: getGameimgurlByGameId(Number(freeSingleId)),
            };
          } else {
            config = promoTypeConfigMap[item.promo_type] || {};
          }
        } else {
          config = promoTypeConfigMap[item.promo_type] || {};
        }

        return {
          ...item,
          cfg_data: safeParseJSON(item.cfg_data),
          ...config,
          button_type:
            item.promo_type === PropEnum.freeBet
              ? item.used_status
                ? 2
                : 1
              : 1,
          button:
            item.promo_type === PropEnum.freeBet && item.used_status
              ? "common.continue"
              : config.button,
          freeSingleId,
        };
      });

    return list;
  };
  return { getUserPromoItemList, filterListData };
}
